import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from "react-select";
import { selectStyles } from "../helper/SelectStyles";
import { Link, useNavigate } from "react-router-dom";
import TablePagination from "./TablePagination";
import StandardDatePicker from "./StandardDatePicker";
import { getManagerStats } from "../Apis/ManagerAPIs";
import { toast } from "react-toastify";

const EventManagerReportLayer = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const fetchManagerStats = async (page = currentPage, limit = rowsPerPage) => {
    try {
      setLoading(true);
      const params = {
        search: searchTerm || undefined,
        page: page , // API usually 1-indexed
        limit: limit
      };
      const result = await getManagerStats(params);
      if (result.status) {
        setReportData(result.response.data || []);
        setTotalRecords(result.response.total || 0);
        setTotalPages(result.response.totalPages || 0);
      }
    } catch (error) {
      console.error("Error fetching manager stats:", error);
      toast.error("Failed to fetch manager statistics");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchManagerStats(currentPage, rowsPerPage);
  }, [searchTerm, currentPage, rowsPerPage]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0);
  };

  return (
    <div className="card h-100 p-0 radius-12 overflow-hidden border-0 shadow-sm">
      <div
        className="card-header border-bottom py-12 px-24 d-flex align-items-center justify-content-between"
        style={{ background: "linear-gradient(135deg, #000000, #bb0007, #ed1c24)" }}
      >
        <h6 className="text-white mb-0 fw-bold ">Event Manager Report</h6>
        
        <div className="position-relative" style={{ width: "280px" }}>
            <input 
                type="text" 
                className="form-control radius-8 ps-40 py-10 bg-white border-0"
                               style={{ height: "44px" }}
                placeholder="Search Manager Name..." 
                value={searchTerm}
                onChange={handleSearch}

            />
            <Icon 
                icon="solar:magnifer-linear" 
                className="position-absolute start-0 top-50 translate-middle-y ms-12 text-dark opacity-75" 
            />
        </div>
      </div>
      
      <div className="card-body p-16">
        <div className="table-responsive border radius-8 bg-white overflow-x-auto shadow-sm mb-16">
          <table className="table bordered-table sm-table mb-0" style={{ minWidth: '1150px' }}>
            <thead>
              <tr style={{ background: "linear-gradient(135deg, #bb0007, #ed1c24)" }}>
                <th className="fw-bold text-white py-12 px-16" style={{ width: '70px' }}>S.No</th>
                <th className="fw-bold text-white py-12" style={{ width: '250px' }}>Event Manager Name</th>
                <th className="fw-bold text-white py-12 text-center" style={{ width: '150px' }}>Mobile Number</th>
                {/* <th className="fw-bold text-white py-12" style={{ width: '200px' }}>Location</th> */}
                <th className="fw-bold text-white py-12 text-center" style={{ width: '120px' }}>Total Expo</th>
                <th className="fw-bold text-white py-12 text-center" style={{ width: '120px' }}>Current Expo</th>
                <th className="fw-bold text-white py-12 text-center" style={{ width: '120px' }}>Past Expo</th>
                <th className="fw-bold text-white py-12 text-center" style={{ width: '100px' }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" className="text-center py-24">
                    <div className="spinner-border text-danger" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </td>
                </tr>
              ) : reportData.length > 0 ? (
                reportData
                  .map((item, index) => (
                  <tr key={index}>
                    <td className="py-10 px-16">
                        <div>{currentPage * rowsPerPage + index + 1}</div>
                    </td>
                    <td className="py-10">
                        <div >{item.name}</div>
                    </td>
                    <td className="py-10 text-center">
                        <div>{item.phoneNumber || item.mobileNumber || "N/A"}</div>
                    </td>
                    {/* <td className="py-10">
                        <div>{item.location || "-"}</div>
                    </td> */}
                    <td className="py-10 text-center">
                        <span className="text-secondary-light fw-bold" style={{ fontSize: "14px" }}>
                            {item.totalExpos}
                        </span>
                    </td>
                    <td className="py-10 text-center">
                        <span className="text-secondary-light fw-bold" style={{ fontSize: "14px" }}>
                            {item.currentExpos}
                        </span>
                    </td>
                    <td className="py-10 text-center">
                        <span className="text-secondary-light fw-bold" style={{ fontSize: "14px" }}>
                            {item.pastExpos}
                        </span>
                    </td>
                    
                    <td className="py-10 text-center">
                      <div className="d-flex align-items-center justify-content-center gap-2">
                        <Link
                            to={`/reports/event-manager/view/${item._id || item.id}`}
                            className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-32-px h-32-px d-inline-flex justify-content-center align-items-center rounded-circle border-0"
                            title="View Details"
                        >
                            <Icon icon="majesticons:eye-line" className="text-lg" />
                        </Link>
                        <Link
                            to={`/reports/event-manager/history/${item._id || item.id}`}
                            className="bg-success-focus bg-hover-success-200 text-success-600 fw-medium w-32-px h-32-px d-inline-flex justify-content-center align-items-center rounded-circle border-0"
                            title="View History"
                        >
                            <Icon icon="solar:history-bold" className="text-lg" />
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center py-24 text-secondary-light">
                    No matching event managers found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <TablePagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={(page) => setCurrentPage(page)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value));
            setCurrentPage(0);
          }}
          totalRecords={totalRecords}
        />
      </div>
    </div>
  );
};

export default EventManagerReportLayer;


